import { useMutation } from "urql";

import { ImportInvoicePaymentDocument } from "../../../graphql/generated.ts";

export function useImportInvoicePayment() {
  return useMutation(ImportInvoicePaymentDocument);
}
